import React from "react";
import { Trans, useTranslation } from "react-i18next";
import Button from "../Button/Button";
import styles from "./DeleteConfirmationPopUp.module.scss";

interface DeleteConfirmationProps {
  id?: string;
  onCancel: () => void;
  onDelete: () => void;
  titleLabel: string;
  msgText: string;
  buttonLabelOne: string;
  buttonLabelTwo: string;
  customStyle?: React.CSSProperties;
  viewName?: string;
  isaboAssignement?: boolean;
}

const DeleteConfirmationPopUp: React.FC<DeleteConfirmationProps> = ({
  id,
  onCancel,
  onDelete,
  titleLabel,
  msgText,
  buttonLabelOne,
  buttonLabelTwo,
  customStyle,
  viewName,
  isaboAssignement,
}) => {
  return (
    <div
      className={`${styles.confirmation_popup_container}`}
      data-testid="delete_document_confirmation_testID"
    >
      <div className={`${styles.title_container}`}>{titleLabel}</div>
      <div className={`${styles.message_container}`}>
        {isaboAssignement && viewName ? (
          <Trans
            i18nKey="delete_view_confirmation_msg"
            values={{ name: viewName || "This" }}
            components={{bold : <strong/>}}
          />
        ) : (
          msgText
        )}
      </div>
      <div className={`${styles.actionButton_container}`}>
        <Button
          id="noCancelButton"
          onClick={onCancel}
          label={buttonLabelOne}
          style="unfilled"
          customStyle={customStyle}
        />
        <Button
          id="yesCancelButton"
          onClick={onDelete}
          label={buttonLabelTwo}
          style="filled"
          customStyle={customStyle}
        />
      </div>
    </div>
  );
};

export default DeleteConfirmationPopUp;
